import ArticlePeopleNews from './articlePeopleNews'

const articlePeopleNews = new ArticlePeopleNews()
articlePeopleNews.init()
